import { useAgendamentoLink } from "@/lib/itv/agendamento";

export function WhatsAppFlutuante() {
  const link = useAgendamentoLink();

  return (
    <a
      className="whatsapp-flutuante"
      href={link}
      aria-label="Agendar consulta pelo WhatsApp"
    >
      <svg viewBox="0 0 32 32" width="28" height="28" aria-hidden="true">
        <path d="M16 3a12.5 12.5 0 0 0-10.7 19L3.5 28.5l6.7-1.8A12.5 12.5 0 1 0 16 3Zm0 2.4a10.1 10.1 0 1 1-5.2 18.8l-.4-.2-3.6 1 1-3.5-.3-.5A10.1 10.1 0 0 1 16 5.4Zm-5 5.1c-.3 0-.7.1-.9.4-.3.3-1.2 1.1-1.2 2.8s1.2 3.2 1.4 3.4c.2.2 2.4 3.8 6 5.1 3 1.1 3.6.9 4.3.8.7-.1 2.2-.9 2.5-1.8.3-.9.3-1.7.2-1.8-.1-.2-.4-.3-.9-.5l-2.5-1.2c-.4-.1-.7-.2-1 .3l-1.2 1.5c-.2.3-.5.3-.9.1a10 10 0 0 1-3-1.8 11 11 0 0 1-2-2.6c-.2-.4 0-.6.2-.8l.6-.7.4-.7c.1-.2 0-.5 0-.7l-1.1-2.6c-.3-.7-.6-.7-.9-.7Z" />
      </svg>
      <span className="whatsapp-flutuante__notificacao" aria-hidden="true" />
    </a>
  );
}